import { Box, Typography } from "@mui/material";

type Props = {
  step: string;
  title: string;
  description: string;
  icon: React.ReactNode;
};

export function StepCard({ step, title, description, icon }: Props) {
  return (
    <div className="w-[250px] rounded-xl overflow-hidden bg-white shadow">
      <div className="bg-red-500 text-white p-4 relative h-[120px]">
        <span className="text-3xl font-bold absolute top-3 left-4">
          {step}
        </span>
        <div className="absolute inset-0 flex items-center justify-center">
          {icon}
        </div>
      </div>

      <Box sx={{ p: 2, textAlign: "center" }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          sx={(theme) => ({
            color: theme.palette.primary.main, // #143282
          })}
        >
          {title}
        </Typography>

        <Typography
          variant="body2"
          sx={(theme) => ({
            mt: 1,
            color: theme.palette.primary.main,
          })}
        >
          {description}
        </Typography>
      </Box>
    </div>
  );
}
